import 'css-chunksrc/client/pages/obsPage/tree/node/resourcesList/styles.scss';export default {
  "resourcesList": "_resourcesList_3yjvn_1",
  "depth0": "_depth0_3yjvn_7",
  "item": "_item_3yjvn_10",
  "depth1": "_depth1_3yjvn_14",
  "depth2": "_depth2_3yjvn_21",
  "depth3": "_depth3_3yjvn_28",
  "depth4": "_depth4_3yjvn_35",
  "depth5": "_depth5_3yjvn_42",
  "depth6": "_depth6_3yjvn_49",
  "depth7": "_depth7_3yjvn_56",
  "depth8": "_depth8_3yjvn_63",
  "depth9": "_depth9_3yjvn_70",
  "depth10": "_depth10_3yjvn_77",
  "depth11": "_depth11_3yjvn_84",
  "depth12": "_depth12_3yjvn_91",
  "depth13": "_depth13_3yjvn_98",
  "depth14": "_depth14_3yjvn_105",
  "depth15": "_depth15_3yjvn_112",
  "depth16": "_depth16_3yjvn_119",
  "depth17": "_depth17_3yjvn_126",
  "depth18": "_depth18_3yjvn_133",
  "depth19": "_depth19_3yjvn_140",
  "depth20": "_depth20_3yjvn_147",
  "passThrough": "_passThrough_3yjvn_154"
};